<!--学生端-专业计划-->
<template>
  <div class="uni-major-plan bjStyle">
    <div class="box majorPlan">
      <el-tabs v-model="activeName">
        <el-tab-pane label="专业计划" name="first">
          <div class="majorPlan-table">
            <h2>{{tableData.student_type == 1?'认定学分课程':'专业基础课'}}</h2>
            <el-table
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              :data="tableData.recognize"
              border
              style="width: 100%"
            >
              <el-table-column prop="code" label="课程代码" width="180">
              </el-table-column>
              <el-table-column prop="title" label="课程名称"> </el-table-column>
              <el-table-column label="学分" width="150">
                <template v-slot="scoped">
                  <span v-if="scoped.row.credit"
                    >{{ scoped.row.credit }}分</span
                  >
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="学期">
                <template v-slot="scoped">
                  {{scoped.row.semester}}
                </template>
              </el-table-column>
              <el-table-column label="课程总成绩" width="150">
                <template v-slot="scoped">
                  <span v-if="!scoped.row.is_assess">无考核</span>
                  <div v-else>
                    <span v-if="scoped.row.score_total"
                      >{{scoped.row.score_total}}分</span
                    >
                    <span v-else>以考试成绩为准</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="enableTime" label="课程成绩构成">
                <template v-slot="scoped">
                  <span v-if="!scoped.row.is_assess">-</span>
                  <div v-else>
                    <p v-if="scoped.row.score_usual" style="margin-right: 10px">
                      平时成绩：{{ scoped.row.score_usual }}%
                    </p>
                    <p v-if="scoped.row.class_hours">
                      听课学时：{{ scoped.row.class_hours }}%
                    </p>
                    <p
                      v-if="scoped.row.score_line"
                      style="margin-right: 10px"
                    >
                      考试成绩：{{ scoped.row.score_line }}%
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>


            <!-- 国家统考课程 -->
            <h2>{{tableData.student_type == 1?'国家统考课程':'公共课'}}</h2>
            <el-table
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              :data="tableData.exam_course"
              border
              style="width: 100%"
              v-if="tableData.student_type == 1"
            >
              <el-table-column prop="code" label="课程代码" width="180">
              </el-table-column>
              <el-table-column prop="title" label="课程名称"></el-table-column>
              <el-table-column label="学分" width="150">
                <template v-slot="scoped">
                  <span v-if="scoped.row.credit"
                    >{{ scoped.row.credit }}分</span
                  >
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>

            <el-table
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              :data="tableData.exam_course"
              border
              style="width: 100%"
              v-if="tableData.student_type == 2"
            >
              <el-table-column prop="code" label="课程代码" width="180">
              </el-table-column>
              <el-table-column prop="title" label="课程名称"> </el-table-column>
              <el-table-column label="学分" width="150">
                <template v-slot="scoped">
                  <span v-if="scoped.row.credit"
                  >{{ scoped.row.credit }}分</span
                  >
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="学期">
                <template v-slot="scoped">
                  {{scoped.row.semester}}
                </template>
              </el-table-column>
              <el-table-column label="课程总成绩" width="150">
                <template v-slot="scoped">
                  <span v-if="!scoped.row.is_assess">无考核</span>
                  <div v-else>
                    <span v-if="scoped.row.score_total"
                    >{{scoped.row.score_total}}分</span
                    >
                    <span v-else>以考试成绩为准</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="enableTime" label="课程成绩构成">
                <template v-slot="scoped">
                  <span v-if="!scoped.row.is_assess">-</span>
                  <div v-else>
                    <p v-if="scoped.row.score_usual" style="margin-right: 10px">
                      平时成绩：{{ scoped.row.score_usual }}%
                    </p>
                    <p v-if="scoped.row.class_hours">
                      听课学时：{{ scoped.row.class_hours }}%
                    </p>
                    <p
                      v-if="scoped.row.score_line"
                      style="margin-right: 10px"
                    >
                      考试成绩：{{ scoped.row.score_line }}%
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>


            <h2 style="margin-top: 20px" v-if="tableData.student_type == 2">专业课</h2>
            <el-table
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              :data="tableData.profession_course"
              border
              style="width: 100%"
              v-if="tableData.student_type == 2"
            >
              <el-table-column prop="code" label="课程代码" width="180">
              </el-table-column>
              <el-table-column prop="title" label="课程名称"> </el-table-column>
              <el-table-column label="学分" width="150">
                <template v-slot="scoped">
                  <span v-if="scoped.row.credit"
                  >{{ scoped.row.credit }}分</span
                  >
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="学期">
                <template v-slot="scoped">
                  {{scoped.row.semester}}
                </template>
              </el-table-column>
              <el-table-column label="课程总成绩" width="150">
                <template v-slot="scoped">
                  <span v-if="!scoped.row.is_assess">无考核</span>
                  <div v-else>
                    <span v-if="scoped.row.score_total"
                    >{{scoped.row.score_total}}分</span
                    >
                    <span v-else>以考试成绩为准</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="enableTime" label="课程成绩构成">
                <template v-slot="scoped">
                  <span v-if="!scoped.row.is_assess">-</span>
                  <div v-else>
                    <p v-if="scoped.row.score_usual" style="margin-right: 10px">
                      平时成绩：{{ scoped.row.score_usual }}%
                    </p>
                    <p v-if="scoped.row.class_hours">
                      听课学时：{{ scoped.row.class_hours }}%
                    </p>
                    <p
                      v-if="scoped.row.score_line"
                      style="margin-right: 10px"
                    >
                      考试成绩：{{ scoped.row.score_line }}%
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="教材版本" name="second">
          <TextbookVersions />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getMajorPlan } from "@/api/basic";
import TextbookVersions from "../textbookVersions";
export default {
  name: "index",
  components: { TextbookVersions},
  data() {
    return {
      tableData: {
        recognize: [],
        exam_course: [],
        profession_course: [],
        student_type:0,
      },
      activeName: "first",
    };
  },
  created() {
    this.getPlan();
  },
  methods: {
    async getPlan() {
      const { result } = await getMajorPlan();
      if (result) {
        const { recognize, exam_course, profession_course, student_type} = result;
        this.tableData.recognize = recognize;
        this.tableData.exam_course = exam_course;
        this.tableData.profession_course = profession_course;
        this.tableData.student_type = student_type;
      }
      console.log(this.tableData);
    },
  },
};
</script>

<style lang="scss" scoped>
// .uni-major-plan {
//   @include bjStyle;
// }
@include bjStyle;
.majorPlan {
  // min-height: inherit;
  // border-radius: 5px;
  // background-color: #ffffff;
  // overflow: hidden;
  // padding: 30px 30px 0;
  h2 {
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
  }
  .majorPlan-table {
    margin-bottom: 40px;
    /deep/ .el-table th {
      text-align: center;
    }
    /deep/ .el-table td {
      text-align: center;
    }
  }
}
</style>

